// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-menu.show {
  bottom: 100% !important;
}

.accordion-item {
  border: none !important;
}

a.dropdown-item:hover, button.dropdown-item:hover {
  background-color: #fff !important;
}

.accordion-button:focus {
  box-shadow: none !important;
}

.accordion-button:hover {
  background-color: transparent !important;
}

.accordion-button {
  display: flex;
  flex-direction: column;
  padding: 15px 0px 0px 0px !important;
}
.accordion-button img {
  max-height: 2.5em !important;
  border-radius: 100% !important;
}

.accordion-header {
  max-width: 100px;
  margin: auto;
  height: 100px;
}

.accordion-button::after {
  background-image: none !important;
}

.empty-head-icon {
  box-shadow: 0 1px 6px #a0afdc, 0 0 #a0afdc !important;
  background: #fff !important;
}

.accordion-button:not(.collapsed) {
  box-shadow: none !important;
  background: transparent !important;
}

.empty-head-icon {
  font-size: 1.5rem;
  padding: 2px;
}

.accordion-body li a {
  align-items: center;
}

.floating {
  animation-name: floating;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  margin-left: 30px;
  margin-top: 5px;
}

@keyframes floating {
  from {
    transform: translate(0, 0px);
  }
  65% {
    transform: translate(0, 15px);
  }
  to {
    transform: translate(0, 0px);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-options/menu-options.component.scss"],"names":[],"mappings":"AAGA;EACI,uBAAA;AAFJ;;AAKE;EACE,uBAAA;AAFJ;;AAIE;EACE,iCAAA;AADJ;;AAGE;EACE,2BAAA;AAAJ;;AAGE;EACE,wCAAA;AAAJ;;AAEE;EACE,aAAA;EACA,sBAAA;EACA,oCAAA;AACJ;AAAI;EACI,4BAAA;EACD,8BAAA;AAEP;;AACE;EACE,gBAAA;EACA,YAAA;EACA,aAAA;AAEJ;;AAAE;EACE,iCAAA;AAGJ;;AAAE;EACE,qDAAA;EACA,2BAAA;AAGJ;;AADE;EACE,2BAAA;EACA,kCAAA;AAIJ;;AAFE;EACE,iBAAA;EACA,YAAA;AAKJ;;AAHE;EACE,mBAAA;AAMJ;;AAHE;EACE,wBAAA;EACA,sBAAA;EACA,mCAAA;EACA,sCAAA;EACA,iBAAA;EACA,eAAA;AAMJ;;AAHA;EACI;IAAO,4BAAA;EAOT;EANE;IAAO,6BAAA;EAST;EARE;IAAO,4BAAA;EAWT;AACF","sourcesContent":[".dropup{\n  \n}\n.dropdown-menu.show{\n    bottom:100% !important;\n  }\n\n  .accordion-item{\n    border: none !important;\n  }\n  a.dropdown-item:hover, button.dropdown-item:hover{\n    background-color: #fff !important;\n }\n  .accordion-button:focus{\n    box-shadow: none !important;\n  }\n\n  .accordion-button:hover{\n    background-color: transparent !important;\n  }\n  .accordion-button{\n    display: flex;\n    flex-direction: column;\n    padding:15px 0px 0px 0px !important;\n    img{\n        max-height: 2.5em !important;\n       border-radius: 100% !important;\n    }\n  }\n  .accordion-header{\n    max-width:100px;\n    margin: auto;\n    height:100px;\n  }\n  .accordion-button::after{\n    background-image: none !important;\n  }\n\n  .empty-head-icon{\n    box-shadow:0 1px 6px #a0afdc,0 0 #a0afdc !important;\n    background: #fff !important;\n  }\n  .accordion-button:not(.collapsed){\n    box-shadow: none !important;\n    background: transparent !important;\n  }\n  .empty-head-icon{\n    font-size:1.5rem;\n    padding:2px;\n  }\n  .accordion-body li a{\n    align-items: center;\n  }\n\n  .floating {  \n    animation-name: floating;\n    animation-duration: 3s;\n    animation-iteration-count: infinite;\n    animation-timing-function: ease-in-out;\n    margin-left: 30px;\n    margin-top: 5px;\n}\n\n@keyframes floating {\n    from { transform: translate(0,  0px); }\n    65%  { transform: translate(0, 15px); }\n    to   { transform: translate(0, -0px); }    \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
